import { subDays, subHours, subMinutes, differenceInMinutes } from "date-fns";
import type { ActivityReminder } from "../../../../../../../../../__generated__/graphql";

export type Reminder = {
  number: number;
  scale: "days" | "hours" | "minutes";
};

export function formatReminderToIsoDate(
  number: number,
  scale: Reminder["scale"],
  startDate: Date
): string {
  let reminderDate;

  switch (scale) {
    case "days":
      reminderDate = subDays(startDate, number);
      break;
    case "hours":
      reminderDate = subHours(startDate, number);
      break;
    case "minutes":
      reminderDate = subMinutes(startDate, number);
  }

  reminderDate.setSeconds(0);
  reminderDate.setMilliseconds(0);

  return reminderDate.toISOString();
}

export function formatActivityRemindersFromIsoDate(
  reminder: ActivityReminder,
  startDate: string
): Reminder | null {
  const difference = differenceInMinutes(
    new Date(startDate),
    new Date(reminder.reminderDate)
  );

  if (difference === 0) {
    return null;
  }

  if (difference % 60 === 0) {
    // If the difference % 60 === 0, then it's a multiple of 60 minutes so it's could be hours or days
    return { number: difference / 60, scale: "hours" };
  } else if (difference % 1440 === 0) {
    // If the difference % 1440 === 0, then it's a multiple of 1440 minutes so it's could be days
    return { number: difference / 1440, scale: "days" };
  } else {
    // Otherwise, it's a multiple of 1 minute so it's minutes
    return { number: difference, scale: "minutes" };
  }
}
